import * as type from '@/constant/redux-const';

export interface FlightData {
  flightId: string;
  flightNumber: string;
  tailNumber: string;
  aircraftType: string;
  origin: string;
  destination: string;
  destinationTimezone?: string;
  originLatitude?: number;
  originLongitude?: number;
  destinationLatitude?: number;
  destinationLongitude?: number;
  latitude: number | null;
  longitude: number | null;
  altitude: number;
  speed: number;
  heading: number;
  status: string;
  eta: string;
  departureTime?: string;
  originTimezone?: string;
  clientId?: number;
  clientName?: string;
  brokerName?: string;
  passengers?: Array<{
    name: string;
    type: string;
  }>;
  pets?: Array<{
    type: string;
    count: number;
  }>;
  positions?: Array<{
    latitude: number;
    longitude: number;
    altitude?: number;
    speed?: number;
    heading?: number;
    timestamp?: string;
  }>;
  tripId?: string;
  tripDisplayName?: string;
  lastUpdate: string;
  isCompleted?: boolean;
  isBlocked?: boolean;
}

export interface FlightFilters {
  broker?: string[];
  client?: string;
  searchQuery?: string;
}

export interface FlightState {
  liveFlights: FlightData[];
  selectedFlight: FlightData | null;
  filters: FlightFilters;
  totalCount: number;
  activeCount: number;
  blockedCount: number;
  isLoading: boolean;
  lastRefreshed: string | null;
}

export const initialState: FlightState = {
  liveFlights: [],
  selectedFlight: null,
  filters: {
    broker: [],
    client: '',
    searchQuery: '',
  },
  totalCount: 0,
  activeCount: 0,
  blockedCount: 0,
  isLoading: false,
  lastRefreshed: null,
};

const flightReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case type.SET_LIVE_FLIGHTS:
      return {
        ...state,
        liveFlights: action.payload.flights || action.payload,
        totalCount: action.payload.totalCount || 0,
        activeCount: action.payload.activeCount || 0,
        blockedCount: action.payload.blockedCount || 0,
      };

    case type.UPDATE_FLIGHT_POSITION:
      return {
        ...state,
        liveFlights: state.liveFlights.map((flight) =>
          flight.flightId === action.payload.flightId
            ? { ...flight, ...action.payload }
            : flight
        ),
      };

    case type.SET_SELECTED_FLIGHT:
      return {
        ...state,
        selectedFlight: action.payload,
      };

    case type.SET_FLIGHT_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    case type.SET_FLIGHTS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case type.SET_FLIGHTS_LAST_REFRESHED:
      return {
        ...state,
        lastRefreshed: action.payload,
      };

    case type.CLEAR_FLIGHTS:
      return {
        ...state,
        liveFlights: [],
        selectedFlight: null,
      };

    default:
      return state;
  }
};

export default flightReducer;
